<template>
  <v-container>
    <template>
      <div class="text-center">
        <v-dialog
          v-model="dialog"
          width="999"
          @click:outside="closeModal"
          :retain-focus="false"
        >
          <v-card class="custom-card" rounded="0">
            <v-toolbar color="secondary" class="white--text">
              <v-toolbar-title class="font-weight-bold">
                {{ $t("ration.prepareRation") }}
              </v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon class="white--text" @click="closeModal">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar>
            <v-card-text>
              <v-row class="py-10 px-4">
                <v-col cols="6" class="text-center">
                  <div class="pa-4 box-wrapper">
                    <div class="icon_wrapper mb-4">
                      <img
                        class="pa-4"
                        src="/icons/feed_management/manual-ration.svg"
                      />
                    </div>

                    <h2 class="black--text" style="font-weight: 900">
                      {{ $t("ration.manualPreparation") }}
                    </h2>
                    <p class="px-10 py-4">
                      {{ $t("ration.manualPreparationText") }}
                    </p>
                    <v-btn-toggle color="green">
                      <v-btn @click="group(`manual`)">
                        {{ $t("group") }}
                      </v-btn>
                      <v-btn @click="individual(`manual`)">
                        {{ $t("individual") }}
                      </v-btn>
                    </v-btn-toggle>
                  </div>
                </v-col>
                <v-spacer></v-spacer>
                <v-col cols="6" class="text-center">
                  <div class="pa-4 box-wrapper">
                    <div class="icon_wrapper mb-4">
                      <img
                        class="pa-4"
                        src="/icons/feed_management/system-suggest-ration.svg"
                      />
                    </div>

                    <h2 class="black--text" style="font-weight: 900">
                      {{ $t("ration.systemPreparation") }}
                    </h2>
                    <p class="px-10 py-4">
                      {{ $t("ration.systemPreparationText") }}
                    </p>

                    <v-btn-toggle color="green">
                      <v-btn @click="group(`system`)">
                        {{ $t("ration.group") }}
                      </v-btn>
                      <v-btn @click="individual(`system`)">
                        {{ $t("ration.individual") }}
                      </v-btn>
                    </v-btn-toggle>
                  </div>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </v-container>
</template>
<script>
export default {
  data() {
    return {};
  },
  computed: {
    dialog() {
      return this.dialogI;
    },
  },

  props: {
    dialogI: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    group(rationType) {
      this.$router.push({
        path: "/feed-management/select-animal-group",
        query: { rationType: rationType },
      });
    },
    individual(rationType) {
      this.$router.push({
        path: "/feed-management/select-animal-individual",
        query: { rationType: rationType },
      });
    },

    closeModal() {
      this.$emit("closeDialog");
    },
  },
};
</script>

<style lang="scss" scoped>
.box-wrapper {
  border: 1px solid #c7d5e1;
  border-radius: 4px;
  height: 23em;
}
.icon_wrapper {
  height: 100px;
  width: 100px;
  border-radius: 50%;
  border: 1px solid #00c26b;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 24px rgba(0, 189, 115, 0.2);
  margin: auto;
  img {
    width: 90px;
  }
}
.v-btn-toggle {
  color: #00c26b;
}
.v-btn-toggle > .v-btn.v-btn--active {
  color: white !important;
  background: #00c26b;
}
.v-btn-toggle:not(.v-btn-toggle--dense) .v-btn.v-btn.v-size--default {
  height: 40px;
  width: 8em;
  color: #00c26b;
}
.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: #00c26b !important;
}

.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn {
  border-color: #00c26b !important;
  color: #00c26b !important; /* Set the default text color to green */
}

.theme--light.v-btn-toggle:not(.v-btn-toggle--group) .v-btn.v-btn:hover {
  border-color: #00c26b !important;
  background-color: #00c26b !important; /* Set the hover background color to green */
  color: #ffffff !important; /* Set the hover text color to white */
}
</style>
